import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CampaignOffers } from './campaignoffers.model';

export interface CampaignOffersState extends EntityState<CampaignOffers> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'campaign-offers', idKey: 'MemberID', cache: { ttl: 30000 } })
export class CampaignOffersStore extends EntityStore<CampaignOffersState> {
  constructor() {
    super();
  }
}
